import { API_URL } from '../../config';
import { CALL_API } from '../../middlewares/apiMiddleware';
import { 
  RESERVATION_POST_RESERVE_INTERVAL,
  RESERVATION_DELETE_FREE_INTERVAL,
  RESERVATION_PUT_CONFIRM,
  PENDING, FULFILLED, REJECTED, 
  RESERVATION_CLICK_CONFIRM_BTN,
  RESERVATION_CHANGE_INPUT,
  RESERVATION_TIME_EXPIRATION,
  RESERVATION_GET_OFFICE_INFO,
} from '../../globals';



export function reserveIntervalRequest() {
  return {
    type: `${RESERVATION_POST_RESERVE_INTERVAL}_${PENDING}`,
  };
}

export function reserveIntervalSuccess(response) {
  return {
    type: `${RESERVATION_POST_RESERVE_INTERVAL}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function reserveIntervalFailure(response) {
  return {
    type: `${RESERVATION_POST_RESERVE_INTERVAL}_${REJECTED}`,
    payload: {
      message: response.response,
    }
  };
}



export function freeIntervalRequest() {
  return {
    type: `${RESERVATION_DELETE_FREE_INTERVAL}_${PENDING}`,
  };
}

export function freeIntervalSuccess(response) {
  return {
    type: `${RESERVATION_DELETE_FREE_INTERVAL}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function freeIntervalFailure(response) {
  return {
    type: `${RESERVATION_DELETE_FREE_INTERVAL}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}

export function confirmReservationRequest() {
  return {
    type: `${RESERVATION_PUT_CONFIRM}_${PENDING}`,
  };
}

export function confirmReservationSuccess(response) {
  return {
    type: `${RESERVATION_PUT_CONFIRM}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
      message: response.message,
    }
  };
}

export function confirmReservationFailure(response) {
  return {
    type: `${RESERVATION_PUT_CONFIRM}_${REJECTED}`,
    payload: {
      status: false,
      message: response.response,
    }
  };
}



export const reserveInterval = (officeId, serviceId, intervalId) => ({
  [CALL_API]: {
    actions: [reserveIntervalRequest, reserveIntervalSuccess, reserveIntervalFailure],
    url: `${API_URL}/web/order`,
    method: 'post',
    data: { 
      store_id: officeId,
      service_id: serviceId,
      interval_id: intervalId,
    },
  },
});

export const freeInterval = (orderId, pin, uuid) => ({
  [CALL_API]: {
    actions: [freeIntervalRequest, freeIntervalSuccess, freeIntervalFailure],
    url: `${API_URL}/web/order/delete`,
    method: 'put',
    data: { 
      order_id: orderId,
      pin: pin,
      uuid: uuid,
    },
  },
});

export const confirmReservation = ({
  id,
  pin,
  name,
  email,
  phone,
  note,
  officeId,
  serviceId,
}) => ({
  [CALL_API]: {
    actions: [confirmReservationRequest, confirmReservationSuccess, confirmReservationFailure],
    url: `${API_URL}/web/order`,
    method: 'put',
    data: { 
      order_id: id,
      pin: pin,
      name: name,
      email: email,
      phone_number: phone,
      note,
      store_id: officeId,
      service_id: serviceId,
    },
  },
});




export function clickBtnConfirm(newNameValid, newEmailValid, newPhoneValid, newNoteValid, newAgreementValid, newCaptcha) {
  return {
    type: `${RESERVATION_CLICK_CONFIRM_BTN}`,
    payload: {
      nameValid: newNameValid, 
      emailValid: newEmailValid, 
      phoneValid: newPhoneValid,
      noteValid: newNoteValid,
      agreementValid: newAgreementValid,
      newCaptcha: newCaptcha,
    }
  };
}

export function changeInput(value, inputName) {
  return {
    type: `${RESERVATION_CHANGE_INPUT}`,
    payload: {
      value: value, 
      inputName: inputName,
    }
  };
}

export function timerExpired() {
  return {
    type: `${RESERVATION_TIME_EXPIRATION}`,
  };
}



export function getOfficeInfoServiceRequest() {
  return {
    type: `${RESERVATION_GET_OFFICE_INFO}_${PENDING}`,
  };
}

export function getOfficeInfoServiceSuccess(response) {
  return {
    type: `${RESERVATION_GET_OFFICE_INFO}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function getOfficeInfoServiceFailure(response) {
  return {
    type: `${RESERVATION_GET_OFFICE_INFO}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}

export const getOfficeInfo = (officeId) => ({
  [CALL_API]: {
    actions: [getOfficeInfoServiceRequest, getOfficeInfoServiceSuccess, getOfficeInfoServiceFailure],
    url: `${API_URL}/web/stores?id=${officeId}`,
  },
});